import { CloseBold } from '@ha/icons';
import React from 'react';
import { makeStyles } from '@material-ui/core';

import { Dialog, IconButton, Popover } from '@ha/dsl';

interface SharedProps {
  open: boolean;
  onClose: () => void;
  onCloseTestLocator?: string;
}

interface DialogProps {
  type: 'dialog';
}

interface PopoverProps {
  type: 'popover';
  anchorEl: HTMLElement | null;
}

const useStyles = makeStyles(() => ({
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
}));

const FilterOverlay: React.FC<SharedProps & (DialogProps | PopoverProps)> = ({
  open,
  onClose,
  onCloseTestLocator = 'Close Modal Button',
  children,
  ...modalProps
}) => {
  const classes = useStyles();

  if (modalProps.type === 'dialog') {
    return (
      <Dialog fullScreen open={open} onClose={onClose}>
        <IconButton
          className={classes.closeButton}
          onClick={onClose}
          data-test-locator={onCloseTestLocator}
        >
          <CloseBold data-test-locator="FilterOverlay/Close" fontSize="small" />
        </IconButton>
        {children}
      </Dialog>
    );
  }

  return (
    <Popover
      open={open}
      anchorEl={modalProps.anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      {children}
    </Popover>
  );
};

export default FilterOverlay;
